// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Introspekcije_introspectionWrapper__hzyhc {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
}
.Introspekcije_title__Rc7RH {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  font-size: 28px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4e4e4e;
  padding-top: 60px;
}
.Introspekcije_element__0X455,
.Introspekcije_polaznikWrapperm__cQONT,
.Introspekcije_btnWrapper__AYgDv,
.Introspekcije_saveBtn__-uRr7,
.Introspekcije_textarea__bI6Cv,
.Introspekcije_editCommentBtn__dCobj,
.Introspekcije_noCommentContainer__IubOo,
.Introspekcije_mentorCommentWrapper__MlRVM,
.Introspekcije_quillContainer__6hD9c {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Introspekcije_backRow__c2l3t {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 16px;
  cursor: pointer;
}
.Introspekcije_navContainer__hhOs4 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  width: 100%;
}
.Introspekcije_element__0X455 {
  gap: 10px;
  -webkit-user-select: none;
          user-select: none;
}
.Introspekcije_title__Rc7RH,
.Introspekcije_paragraph__BgP7W {
  font-family: "Inter", sans-serif;
  font-weight: 600;
}
.Introspekcije_paragraph__BgP7W {
  color: #5f6d7e;
  font-size: 16px;
  -webkit-user-select: none;
          user-select: none;
}
.Introspekcije_navWrapper__6q4BZ {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
}
.Introspekcije_polaznikWrapper__v5iaA {
  width: 100%;
  flex-direction: column;
  gap: 16px;
}
.Introspekcije_btnWrapper__AYgDv {
  width: 100%;
  margin-top: 24px 0px 24px 0px;
  gap: 25px;
}
.Introspekcije_saveBtn__-uRr7 {
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
  border-radius: 4px;
  background-color: #cb9c2d;
  column-gap: 8px;
  height: 52px;
  width: 15%;
  border: none;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  color: white;
}
.Introspekcije_commentRow__w9jOx,
.Introspekcije_commentContainer__eKyRj {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Introspekcije_commentWrapper__VqXbs {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
  flex-direction: column;
  width: 100%;
}
.Introspekcije_avatar__mOJyY {
  width: 64px;
  height: 64px;
  border-radius: 100px;
  object-fit: cover;
  margin-left: 20px;
}
.Introspekcije_commentContainer__eKyRj {
  background-color: #ffffff;
  height: 200px;
  width: 100%;
  border-radius: 10px;
}
.Introspekcije_editCommentBtn__dCobj {
  width: 56px;
  height: 200px;
  border: none;
  border-radius: 0 9px 9px 0;
  background-color: #f4f4f4;
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.Introspekcije_editCommentBtn__dCobj:hover {
  background-color: #e2e2e2;
}
.Introspekcije_commentLabel__52k9L {
  color: #4d4d4d;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.04px;
  font-size: 20px;
}
.Introspekcije_commentLabel__52k9L,
.Introspekcije_textarea__bI6Cv,
.Introspekcije_cancelButtonText__8yeY7,
.Introspekcije_saveButtonText__d3WOB,
.Introspekcije_saveBtn__-uRr7 {
  font-family: Inter;
  font-weight: 600;
}
.Introspekcije_saveBtn__-uRr7:disabled {
  background-color: #cb9c2d;
  cursor: not-allowed;
  opacity: 0.8;
}
.Introspekcije_textarea__bI6Cv {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-decoration: none;
}
.Introspekcije_textarea__bI6Cv,
.Introspekcije_noCommentContainer__IubOo {
  height: 200px;
  width: 100%;
  border-radius: 10px 0 0 10px;
  padding-left: 16px;
  resize: none;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  box-sizing: border-box;
  padding-top: 14px;
  font-size: 20px;
  font-weight: 600;
  color: #5f6d7e;
  border: none;
}
.Introspekcije_noCommentContainer__IubOo:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
  height: 200px;
}
.Introspekcije_mentorCommentWrapper__MlRVM {
  flex-direction: column;
  align-items: flex-start;
}
.Introspekcije_mentorCommentWrapper__MlRVM,
.Introspekcije_editModeButtonscontainer__5IkhA,
.Introspekcije_commentRow__w9jOx {
  gap: 16px;
  width: 100%;
}
.Introspekcije_commentRow__w9jOx {
  border: 2px solid #e2e2e2;
  border-radius: 8px;
}
.Introspekcije_editModeButtonscontainer__5IkhA {
  margin-bottom: 30px;
}
.Introspekcije_cancelButtonText__8yeY7,
.Introspekcije_saveButtonText__d3WOB {
  margin: 0px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.Introspekcije_cancelButton__llwv0,
.Introspekcije_saveButton__OloXc,
.Introspekcije_editModeButtonscontainer__5IkhA {
  display: flex;
  justify-content: center;
}
.Introspekcije_saveButton__OloXc,
.Introspekcije_cancelButton__llwv0 {
  background-color: #cb9c2d;
  border-radius: 4px;
  height: 52px;
  width: 212px;
  align-items: center;
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.Introspekcije_saveButtonText__d3WOB {
  color: #ffffff;
  text-transform: capitalize;
}

.Introspekcije_saveButton__OloXc:hover {
  background-color: #b98d26;
}
.Introspekcije_cancelButton__llwv0 {
  background-color: #ebebeb;
  border-radius: 4px;
  height: 52px;
  width: 212px;
}
.Introspekcije_cancelButton__llwv0:hover {
  background-color: #c7c6c6;
}
.Introspekcije_cancelButtonText__8yeY7 {
  color: #808080;
}
.Introspekcije_commentCharacters__Lq6GL,
.Introspekcije_emptyContainer__c11kO {
  color: #5f6d7e;
  font-family: Inter;
  font-style: normal;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
}
.Introspekcije_emptyContainer__c11kO {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 34px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  background-color: #fcfcfc;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  box-sizing: border-box;
  justify-content: space-between;
}
.Introspekcije_quillContainer__6hD9c {
  flex-direction: column;
  padding-left: 34px;
  padding-right: 34px;
  padding-bottom: 24px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  margin-bottom: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/introspekcije/Introspekcije.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;;;;;;;;;EASE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;;EAEE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,SAAS;AACX;AACA;EACE,eAAe;EACf,8CAA8C;EAC9C,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;;EAEE,aAAa;EACb,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;;EAGE,SAAS;EACT,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;;EAGE,aAAa;EACb,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oDAAoD;EACpD,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".introspectionWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  gap: 16px;\n}\n.title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 90%;\n  font-size: 28px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4e4e4e;\n  padding-top: 60px;\n}\n.element,\n.polaznikWrapperm,\n.btnWrapper,\n.saveBtn,\n.textarea,\n.editCommentBtn,\n.noCommentContainer,\n.mentorCommentWrapper,\n.quillContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.backRow {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 16px;\n  cursor: pointer;\n}\n.navContainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  width: 100%;\n}\n.element {\n  gap: 10px;\n  user-select: none;\n}\n.title,\n.paragraph {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n}\n.paragraph {\n  color: #5f6d7e;\n  font-size: 16px;\n  user-select: none;\n}\n.navWrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: center;\n}\n.polaznikWrapper {\n  width: 100%;\n  flex-direction: column;\n  gap: 16px;\n}\n.btnWrapper {\n  width: 100%;\n  margin-top: 24px 0px 24px 0px;\n  gap: 25px;\n}\n.saveBtn {\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n  border-radius: 4px;\n  background-color: #cb9c2d;\n  column-gap: 8px;\n  height: 52px;\n  width: 15%;\n  border: none;\n  font-size: 15px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: white;\n}\n.commentRow,\n.commentContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.commentWrapper {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 16px;\n  flex-direction: column;\n  width: 100%;\n}\n.avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 100px;\n  object-fit: cover;\n  margin-left: 20px;\n}\n.commentContainer {\n  background-color: #ffffff;\n  height: 200px;\n  width: 100%;\n  border-radius: 10px;\n}\n.editCommentBtn {\n  width: 56px;\n  height: 200px;\n  border: none;\n  border-radius: 0 9px 9px 0;\n  background-color: #f4f4f4;\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.editCommentBtn:hover {\n  background-color: #e2e2e2;\n}\n.commentLabel {\n  color: #4d4d4d;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: -0.04px;\n  font-size: 20px;\n}\n.commentLabel,\n.textarea,\n.cancelButtonText,\n.saveButtonText,\n.saveBtn {\n  font-family: Inter;\n  font-weight: 600;\n}\n.saveBtn:disabled {\n  background-color: #cb9c2d;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n.textarea {\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-decoration: none;\n}\n.textarea,\n.noCommentContainer {\n  height: 200px;\n  width: 100%;\n  border-radius: 10px 0 0 10px;\n  padding-left: 16px;\n  resize: none;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  box-sizing: border-box;\n  padding-top: 14px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #5f6d7e;\n  border: none;\n}\n.noCommentContainer:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n  height: 200px;\n}\n.mentorCommentWrapper {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.mentorCommentWrapper,\n.editModeButtonscontainer,\n.commentRow {\n  gap: 16px;\n  width: 100%;\n}\n.commentRow {\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n}\n.editModeButtonscontainer {\n  margin-bottom: 30px;\n}\n.cancelButtonText,\n.saveButtonText {\n  margin: 0px;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.cancelButton,\n.saveButton,\n.editModeButtonscontainer {\n  display: flex;\n  justify-content: center;\n}\n.saveButton,\n.cancelButton {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  height: 52px;\n  width: 212px;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.saveButtonText {\n  color: #ffffff;\n  text-transform: capitalize;\n}\n\n.saveButton:hover {\n  background-color: #b98d26;\n}\n.cancelButton {\n  background-color: #ebebeb;\n  border-radius: 4px;\n  height: 52px;\n  width: 212px;\n}\n.cancelButton:hover {\n  background-color: #c7c6c6;\n}\n.cancelButtonText {\n  color: #808080;\n}\n.commentCharacters,\n.emptyContainer {\n  color: #5f6d7e;\n  font-family: Inter;\n  font-style: normal;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n}\n.emptyContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 34px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  background-color: #fcfcfc;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  box-sizing: border-box;\n  justify-content: space-between;\n}\n.quillContainer {\n  flex-direction: column;\n  padding-left: 34px;\n  padding-right: 34px;\n  padding-bottom: 24px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  margin-bottom: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"introspectionWrapper": `Introspekcije_introspectionWrapper__hzyhc`,
	"title": `Introspekcije_title__Rc7RH`,
	"element": `Introspekcije_element__0X455`,
	"polaznikWrapperm": `Introspekcije_polaznikWrapperm__cQONT`,
	"btnWrapper": `Introspekcije_btnWrapper__AYgDv`,
	"saveBtn": `Introspekcije_saveBtn__-uRr7`,
	"textarea": `Introspekcije_textarea__bI6Cv`,
	"editCommentBtn": `Introspekcije_editCommentBtn__dCobj`,
	"noCommentContainer": `Introspekcije_noCommentContainer__IubOo`,
	"mentorCommentWrapper": `Introspekcije_mentorCommentWrapper__MlRVM`,
	"quillContainer": `Introspekcije_quillContainer__6hD9c`,
	"backRow": `Introspekcije_backRow__c2l3t`,
	"navContainer": `Introspekcije_navContainer__hhOs4`,
	"paragraph": `Introspekcije_paragraph__BgP7W`,
	"navWrapper": `Introspekcije_navWrapper__6q4BZ`,
	"polaznikWrapper": `Introspekcije_polaznikWrapper__v5iaA`,
	"commentRow": `Introspekcije_commentRow__w9jOx`,
	"commentContainer": `Introspekcije_commentContainer__eKyRj`,
	"commentWrapper": `Introspekcije_commentWrapper__VqXbs`,
	"avatar": `Introspekcije_avatar__mOJyY`,
	"commentLabel": `Introspekcije_commentLabel__52k9L`,
	"cancelButtonText": `Introspekcije_cancelButtonText__8yeY7`,
	"saveButtonText": `Introspekcije_saveButtonText__d3WOB`,
	"editModeButtonscontainer": `Introspekcije_editModeButtonscontainer__5IkhA`,
	"cancelButton": `Introspekcije_cancelButton__llwv0`,
	"saveButton": `Introspekcije_saveButton__OloXc`,
	"commentCharacters": `Introspekcije_commentCharacters__Lq6GL`,
	"emptyContainer": `Introspekcije_emptyContainer__c11kO`
};
export default ___CSS_LOADER_EXPORT___;
